export default function ChangelogPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <h1 className="text-4xl font-bold mb-4">Changelog</h1>
      <p className="text-lg text-gray-700 mb-8">See what's new and improved in Inflatein AI Studio.</p>
    </div>
  )
}
